var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolikuvitus128009(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2,.cls-5{fill:none;}.cls-2,.cls-3{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-4{fill:#969696;}.cls-5{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "106.35 15.47 88.04 38.41 74.67 24.45 49.68 59.26 29.21 34.21 11.17 58.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "84.67 70.72 90.4 58.42 106.35 55.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "11.17 70.46 29.06 89.13 49.27 67.46 59.39 74.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "78.44 53.55 68.7 53.55 73.57 62.75 78.44 53.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.19,89.45c0,12.35-8.78,22.35-19.62,22.35S54,101.8,54,89.45c0-16.9,19.62-26.83,19.62-26.83S93.19,72,93.19,89.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.57,
    y1: 63.27,
    x2: 71.19,
    y2: 67.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.57,
    y1: 63.27,
    x2: 75.95,
    y2: 67.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79,95a5.54,5.54,0,0,1-4.06,1.6c-3.79,0-5.34-2.37-5.57-6h-.81a.61.61,0,1,1,0-1.22h.77V87h-.77a.6.6,0,1,1,0-1.2h.81c.23-3.54,1.87-6.09,5.69-6.09a5.1,5.1,0,0,1,3.9,1.53.93.93,0,0,1,.25.55.73.73,0,0,1-.72.7c-.3,0-.46-.25-.79-.55A4,4,0,0,0,75,81.08c-2.71,0-4,1.71-4.2,4.71h4.78a.6.6,0,0,1,0,1.2H70.79v2.32h4.82a.61.61,0,0,1,0,1.22H70.83c.2,3.11,1.4,4.64,4.08,4.64a4.37,4.37,0,0,0,2.8-.92c.38-.29.54-.52.86-.52a.65.65,0,0,1,.65.68A.83.83,0,0,1,79,95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.76,104.79,42.23,92.08a3.49,3.49,0,0,0-4.63.71c-1.87,2.61.48,4.36.92,4.78,2.68,2.05,16,12.05,21.91,16.13,4,2.76,7.74,5.22,16.41,4.45l26.81-.41,9.32,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.18,110.35S77,110,67.56,110.28c-2.72.07-5.75-.94-5.8-3.59.07-2.19,1.36-3.17,3.89-3.28l3.61.06c10.42.19,15.35-3.17,22.23-2.91a21.82,21.82,0,0,1,13.23,5.31l8,.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.12,
    y: 104,
    width: 7.71,
    height: 15.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "100.27 51.26 107.47 54.87 102.53 61.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "99.02 16.1 106.93 14.59 107.06 22.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 128,
    height: 128
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolikuvitus128009);
export default __webpack_public_path__ + "static/media/symbolikuvitus_128_009.084dd643d9582d39bf303fc1d78d64fc.svg";
export { ForwardRef as ReactComponent };